import { roleDataService } from "./services";
import { RoleCard, RoleItemPage } from "./components";
import { faUserGear } from "@fortawesome/free-solid-svg-icons";
import { IModuleConfig } from "../../interfaces";
import { ModuleTypeEnum } from "../../enums";
import {
  AddButton,
  CancelButton,
  DeleteButton,
  EditButton,
  SaveButton,
} from "./components/toolbar-items";
import {UserPermissions} from "../../definitions"

const config: IModuleConfig = {
  id: "roles",
  name: "User Roles",
  view_permission: UserPermissions.viewUserRoles,
  edit_permission: UserPermissions.editUserRoles,
  icon: faUserGear,
  moduleType: ModuleTypeEnum.DualPaneLibrary,
  allowSearch: true,
  components: {
    libraryCard: RoleCard,
    itemPage: RoleItemPage,
  },
  services: {
    getByPage: roleDataService.getByPage,
    getSingle: roleDataService.getSingle,
    create: roleDataService.create,
    update: roleDataService.update,
  },
  utilities: {
    extractKey: (d: any) => d._id,
    extractItemPath: (d: any) => d._id,
    extractItemBreadcrumb: (d: any) => {
      return d.email_address;
    },
  },
  toolbarItems: {
    library: [AddButton],
    create: [CancelButton, SaveButton],
    edit: [CancelButton, SaveButton],
    view: [AddButton, EditButton, DeleteButton],
  },
};

export default config;
